import { createSlice } from '@reduxjs/toolkit';

import type { AsyncStatus } from '@/shared/types/asyncState';

import type { DashboardAtendimentoData } from '../../types/dashboardAtendimento';

import { fetchDashboardAtendimento } from './actions';

interface DashboardAtendimentoState {
  /** Mantido durante o recarregamento: trocar de período não apaga a tela e ela não pula. */
  data: DashboardAtendimentoData | null;
  status: AsyncStatus;
  error: string | null;
  /**
   * Trocar de período dispara um fetch novo antes do anterior voltar. Sem esta guarda, a resposta
   * atrasada do período antigo sobrescreveria a do período escolhido.
   */
  requestIdAtual: string | null;
}

const initialState: DashboardAtendimentoState = {
  data: null,
  status: 'idle',
  error: null,
  requestIdAtual: null,
};

const dashboardAtendimentoSlice = createSlice({
  name: 'dashboardAtendimento',
  initialState,
  reducers: {
    resetDashboardAtendimento: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardAtendimento.pending, (state, action) => {
        state.status = 'loading';
        state.error = null;
        state.requestIdAtual = action.meta.requestId;
      })
      .addCase(fetchDashboardAtendimento.fulfilled, (state, action) => {
        if (state.requestIdAtual !== action.meta.requestId) return;
        state.data = action.payload;
        state.status = 'success';
      })
      .addCase(fetchDashboardAtendimento.rejected, (state, action) => {
        // Abortada é a requisição que a troca de período cancelou de propósito: não é erro.
        if (action.meta.aborted || state.requestIdAtual !== action.meta.requestId) return;
        state.status = 'error';
        state.error = action.payload ?? 'Erro desconhecido';
      });
  },
});

export const { resetDashboardAtendimento } = dashboardAtendimentoSlice.actions;
export const dashboardAtendimentoReducer = dashboardAtendimentoSlice.reducer;
